export const loginUser = [
  {
    type: "text",
    name: "name",
    text: "name",
    label: "Email",
    placeholder: "User Email",
  },
  {
    type: "password",
    name: "password",
    text: "password",
    label: "Password",
    placeholder: "Password",
  },
]
export const forget = [
  {
    type: "text",
    name: "name",
    text: "name",
    label: "Email",
    placeholder: "User Email",
  },
]

export const PDFUser = [
  {
    type: "text",
    name: "orgName",
    text: "orgName",
    label: "Partner Organization Name ",
    placeholder: "Enter Partner Organization Name",
  },
]
export const PDFUser2 = [
  {
    type: "text",
    name: "tagLine",
    text: "tagLine",
    label: "Partner Organization Tag Line",
    placeholder: "Enter Partner Organization Tag Line",
  },
]
export const checkbox = [
  {
    label: "Remember me",
  },
]
export const forgetPassword = [
  {
    type: "text",
    name: "email",
    text: "email",
    label: "Email",
    placeholder: "Enter your email",
  },
]
export const resetPassword = [
  {
    type: "password",
    name: "newpassword",
    text: "newpassword",
    label: "newpassword",
    placeholder: "New Password",
  },
  {
    type: "password",
    name: "confrimpassword",
    text: "confrimpassword",
    label: "confrimpassword",
    placeholder: "Confirm Password",
  },
]
export const EditProfile = [
  {
    type: "text",
    name: "firstName",
    text: "firstName",
    label: "First Name ",
    placeholder: "Enter First Name",
  },
  {
    type: "text",
    name: "lastName",
    text: "lastName",
    label: "Last Name ",
    placeholder: "Enter Last Name",
  },
  // {
  //   type: "text",
  //   name: "name", // Update the name to match the property in the initialValues
  //   text: "name",
  //   label: "User Name",
  //   placeholder: "User Name",
  // },
  {
    type: "text",
    name: "contactNumber", // Update the name to match the property in the initialValues
    text: "text",
    label: "Contact Number",
    placeholder: "Contact Number",
    maxLength: 14, // Set the maximum length to 14
  },
  {
    type: "text",
    name: "email",
    text: "email",
    label: " Email ",
    placeholder: " Email",
  },
]

export const createinvite = [
  {
    type: "text",
    name: "firstName",
    text: "firstName",
    label: "First Name ",
    placeholder: "Enter First Name",
  },
  {
    type: "text",
    name: "lastName",
    text: "lastName",
    label: "Last Name ",
    placeholder: "Enter Last Name",
  },
  {
    type: "text",
    name: "email",
    text: "email",
    label: "User Email ",
    placeholder: "Enter User Email",
  },
  {
    type: "text",
    name: "confirmEmail",
    text: "Confirm Email",
    label: "Confirm User Email",
    placeholder: "Confirm Email",
  },

  // {
  //   type: "text",
  //   name: "name", // Update the name to match the property in the initialValues
  //   text: "name",
  //   label: "User Name",
  //   placeholder: "Enter User Name",
  // },
  {
    type: "text",
    name: "contactNumber", // Update the name to match the property in the initialValues
    text: "number",
    label: " Contact Number",
    placeholder: "Enter User Contact Number",
    maxLength: 15,
    minLenghth: 15,
  },
]

export const updateRole = [
  {
    type: "text",
    name: "firstName",
    text: "firstName",
    label: "First Name ",
    placeholder: "Enter First Name",
  },
  {
    type: "text",
    name: "lastName",
    text: "lastName",
    label: "Last Name ",
    placeholder: "Enter Last Name",
  },
  {
    type: "text",
    name: "email",
    text: "email",
    label: "User Email ",
    placeholder: "Enter User Email",
  },
]
export const EstimateColumn = [
  { label: "Estimate Name", field: "est_name" },
  { label: "Customer Name", field: "customer_name" },
  { label: "Created Date", field: "created_date" },
  { label: "Status", field: "status" },
  { label: "Action", field: "action" },
]

export const UserProfileColumn = [
  { label: "User Name", field: "firstName" },
  { label: "User Email", field: "userName" },
  { label: "Type of User", field: "roles" },
  { label: "Last  Login Date", field: "lastLoginDate" },
  { label: "User Status", field: "isActive" },
  { label: "Action", field: "isActive", isAction: true },
]
export const PartnersColumn = [
  { label: "User Email", field: "userName" },
  { label: "User Type", field: "roleId" },
  { label: "Last  Login Date", field: "lastLoginDate" },
  { label: "User Status", field: "isActive" },
  { label: "Action", field: "action", isAction: true },
]

export const convertToCurrency = (number: number, currency = "USD") => {
  return new Intl.NumberFormat("en-US", {
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number)
}

export const EstimateAccordionTableColumn: any = [
  { label: "ROI Name", field: "estName", isRedirect: true },
  { label: "Product Name", field: "prodCombinationId" },

  { label: "Created Date", field: "createdAt" },
  { label: "Status", field: "state" },
  {
    label: "Action",
    field: "isEstimateAction",
    isAction: true,
    isEstimateAction: true,
  },
]
export const Partnerconst = [
  {
    type: "text",
    name: "orgName",
    text: "orgName",
    label: "Organization Name  ",
    placeholder: "Enter Name ",
  },
  {
    type: "text",
    name: "firstName",
    text: "firstName ",
    label: "First Name  ",
    placeholder: "Enter First Name ",
  },
  {
    type: "text",
    name: "lastName",
    text: "lastName",
    label: "Last Name ",
    placeholder: "Enter Last Name ",
  },
  {
    type: "text",
    name: "userEmail",
    text: "userEmail",
    label: "Email",
    placeholder: "Enter Email",
    isDisableOnEdit: true,
  },

  {
    type: "text",
    name: "confirmpartneradminemail", // Update the confirmpartneradminemail  to match the popertyan theinitialValues
    text: "confirmpartneradminemail",
    label: "Confirm Email",
    placeholder: "Enter Confirm Email",
    isDisableOnEdit: true,
  },
  {
    type: "text",
    name: "phoneNumber", // Update thename to match the property in the initialValues
    text: "phoneNumber",
    label: " Contact Number",
    placeholder: "Enter User Contact Number",
    maxLength: 15,
    minLenghth: 15,
  },
]
export const PartnerUserconst = [
  {
    type: "text",
    name: "firstName",
    text: "firstName",
    label: "First Name  ",
    placeholder: "Enter First Name ",
  },
  {
    type: "text",
    name: "lastName",
    text: "lastName",
    label: "Last Name ",
    placeholder: "Enter Last Name ",
  },
  {
    type: "text",
    name: "userEmail",
    text: "userEmail",
    label: "Email",
    placeholder: "Enter Email",
    isDisableOnEdit: true,
  },

  {
    type: "text",
    name: "confirmEmail", // Update the confirmemail  to match the popertyan theinitialValues
    text: "confirmEmail",
    label: "Confirm Email",
    placeholder: "Enter Confirm Email",
    isDisableOnEdit: true,
  },
  {
    type: "text",
    name: "phoneNumber", // Update thename to match the property in the initialValues
    text: "phoneNumber",
    label: "Contact Number",
    placeholder: "Enter User Contact Number",
    maxLength: 15,
    minLenghth: 15,
  },
]
export const NO_RECORDS_FOUND = "No Records Found."
export const Customer_Name = "Customer Name"
export const Account_Name = "Account Name"
export const Account_EMAIL = "Email Id"
export const ROI_TYPE = "ROI Type"
export const ACTION_TYPE = "Action"
export const Create_ROI = "Create ROI"
export const ROI_Estimates_List = "ROI Estimates List"
export const ROI_Estimate_Federal = "Federal Estimates List"
export const Forgot_Password = "Forgot Password?"
export const Download_ROI_Report = "Download ROI Report"
export const Set_New_Password = "Set New Password"
export const Please_enter_new_password_and_confirm_password =
  "Please enter new password and confirm password."
export const Reset_Password = "Reset Password"
export const text_content =
  "Enter the user name associated with your account and we’ll send an email with instructions to reset your password."
export const User_Profile = "User Profile"
export const Onboard_User = "Onboard User"
export const Edit_Federal_Configuration = "Edit Federal Configuration"
export const Edit_Industry_Configuration = " Edit Industry Configuration"
export const Reverbed_pdf_foote_text= "Riverbed is the only company with the collective richness of telemetry from network to app to end user that illuminates and then accelerates every interaction so that users get the flawless digital experience they expect across the entire digital ecosystem. Riverbed offers two industry leading solution areas – an innovative and differentiated Unified Observability portfolio that unifies data, insights, and actions across IT, so customers can deliver seamless digital experiences; and Riverbed Acceleration, providing fast, agile, secure acceleration of any app over any network to users, whether mobile, remote, or on-prem. Together with our thousands of partners, and market-leading customers across the world, we empower every click, every digital experience. Learn more at riverbed.com"
export const Reverbed_pdf_2foote_text= " Riverbed Technology LLC. All rights reserved. Riverbed and any Riverbed product or service name or logo used herein are trademarks of Riverbed. All other trademarks used herein belong to their respective owners. The trademarks and logos displayed herein may not be used without the prior written consent of Riverbed or their respective owners. ROI_US_120723"
export const Close= "Close"
export const Your_Return_on_Investment_Report= "Your Return on Investment Report"
export const Aternity_NPM_IQ= "Aternity, NPM, IQ"
export const Riverbed_Empower_the_Experience= "Riverbed — Empower the Experience"
export const All_rights_reserved= "All rights reserved."
export const Your_Sincerely= "Your Sincerely"
export const Confirm = "Confirm"
export const Resend_Invite = "Resend Invite"
export const Create_User = "Create User"
export const Update_user = "Update User"
// export const Choose_Your_Product_to_Start_Creating_ROI =
//   "Choose Product(s) to Start Creating ROI for New Customer"
export const Choose_Business_User_Type = "Choose Type of Business"
export const Business_test = "Choose the type of ROI from New Business, Ongoing Customer ROI review , Renewal, or Tool Consolidation​"
export const Select_Product_User_Want = " Select  product to be Added"
export const Select_Product_User_Hass = "Select the products your customer already  has"

export const Select_Product_User_Want_Add = "Select the products your customer wants to add"
export const Select_Product_User_Like = "Select the products you'd like to include in this ROI estimate for your new customer."
export const Select_Product_User_Has = "Select the products your customer wishes  to review their current ROI for"
export const Choose_Product_User_Want = "Choose  products  customer wishes to buy to create ROI for New Business."
export const Choose_Product_User_Has = "Choose the products your customer currently has under contract to include them in the ROI estimate."
export const Edit_Product = "Edit Product Combination"
export const product_modal_text =
  "Choose  existing product to review  Ongoing Customer​  ROI."
export const product_model_test_bussnes2 =
  "The current products  are assumed to renew. Optionally  pick any additional products your customer is interested in adding to their current Riverbed platform."
export const edit_modal_text =
  "Explore our array of products and select one or multiple to initiate the process of generating detailed ROI report tailored to business needs."
export const clone_title = "Clone ROI Estimate"
export const clone_text = " Please enter a new name for cloned ROI."
export const Onboard_Partner = "Onboard Partner"
export const Onboard_Partner_Admin = "Onboard Partner Admin"
export const Edit_Partners_Details = "Edit Partners Details"
export const Deactivate_Partner = "Deactivate Partner"
export const Activate_Partner = "Activate Partner"
export const Edit_Partner_Detail = "Edit Partner Detail"
export const Edit_Partner_User_Detail = "Edit Partner User Detail"
export const Onboard_Federal = "Onboard Federal"
export const Onboard_Federal_Admin = "Onboard Federal Admin"
export const Edit_Federals_Details = "Edit Federals Details"
export const Deactivate_Federal = "Deactivate Federal"
export const Activate_Federal = "Activate Federal"
export const Edit_Federal_Detail = "Edit Federal Detail"
export const Edit_Federal_User_Detail = "Edit Federal User Detail"
export const View_Pdf = "View Pdf"
export const Partner_User_Details = "Partner User Details"
export const Create_New_Role = "Create New Role"
export const View_PDF_Template = "View PDF Template"
export const Save_Template = "Save Template"
export const PDF_Report_Start_Page = "PDF Report Start Page"
export const PDF_Footer = "PDF Footer"
export const Cancel = "Cancel"
export const Edit = "Edit"
export const PDF_Template = "PDF Template"
export const Generic_Company = "Generic Company"
export const Logged_In = "Logged In"
export const User_Role = "User Role"
export const Riverbed_Technology_All_rights_reserved = "Riverbed Technology. All rights reserved."
export const Partners = "Partners"
export const Federal = "Federals"
export const Manage_Roles = "Manage Roles"
export const MANAGER_USER_PARTNER = "User Profiles"
export const Edit_PDF_Template = "Edit PDF Template"
export const Onboard_Partner_User = "Onboard Partner User"
export const Create_Partner = "Create Partner"
export const Save_Changes = "Save Changes"
export const Generate_ROI = "Generate ROI"
export const Save = "Save"
export const image_text = "Please upload logo image, size less than 2MB"
export const image_text2 = "For optimal viewing, please use a logo no larger than 1024x1024 pixels."

export const Upload_Partner_Logo = "Upload Partner Logo"
export const Partner_Logo = "Partner Logo"
export const Choose_File = "Choose File"

export const USER_PERMISSIONS = [
  {
    id: 1,
    name: "Industry Configuration",
  },
  {
    id: 2,
    name: "User Management",
  },
  {
    id: 3,
    name: "Partner Onboarding",
  },
  {
    id: 4,
    name: "PDF Branding Management",
  },
  {
    id: 5,
    name: "Partner User Management",
  },
  {
    id: 6,
    name: "Create ROI",
  },
  {
    id: 7,
    name: "Delete ROI",
  },
  {
    id: 8,
    name: "Partner User Management",
  },
  {
    id: 9,
    name: "PDF Branding Management",
  },
  {
    id: 10,
    name: "Create ROI",
  },
  {
    id: 13,
    name: "Federal ROI",
  }
]
